import { useDispatch, useSelector } from "react-redux";
import { setSelectedConfig } from "../redux/store/genericReportingSlice";
import { Select, Skeleton } from "antd";
import { useGetActiveProductGroupConfigQuery, useListProductGroupConfigsQuery } from "../redux/api/productGrouping";
import { useEffect } from "react";
import TooltipContainer from "../components/UI/TooltipContainer";

export default function ProductGroupConfigDropdown({
    platform = 'Shopify'
}) {
    const dispatch = useDispatch();

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedClientRegion = useSelector((state) => state.genericReporting.selectedDropdownValues['single_select_client_region']);
    const selectedConfig = useSelector((state) => state.genericReporting.selectedConfig);

    const activeConfig = useGetActiveProductGroupConfigQuery({
        client: selectedClient,
        clientRegion: selectedClientRegion,
        platform: platform
    });

    const configOptions = useListProductGroupConfigsQuery(
        {
            client: selectedClient,
            clientRegion: selectedClientRegion,
            platform: platform
        }
    );

    useEffect(() => {
        if (activeConfig.status === 'fulfilled') {
            dispatch(setSelectedConfig(activeConfig.data));
        }
    }, [activeConfig, configOptions, selectedClient]);

    return (
          <div style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            marginLeft: "0.5vw",
            marginRight: "0.5vw"
          }}>
            <>
            <h4>Product Group</h4>
            <Select 
                    value={selectedConfig}
                    style={{
                        width: '10vw'
                    }}
                    options={configOptions.data?.map((config) => {
                        return {
                            'label': config,
                            'value': config
                        }
                    })}
                    onChange={(value) => {
                        dispatch(setSelectedConfig(value));
                    }}
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={!configOptions.data || configOptions.data.length === 0}
                    loading={configOptions.isFetching}
                />
                </>
        </div>
    )
}